<template>
<!--  viewBox="0 0 14 12"-->
    <path fill="currentColor" d="M7 12L0.0717975 -1.30507e-06L13.9282 -9.36995e-08L7 12Z"/>
</template>